import { Avatar, Box, Divider, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import DUMMY from "../../Assets/User.webp";
import Fire from "../../Assets/fire.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import AxiosInstance from "../../Config/AxiosInstance";
import { ApiList } from "../../Config/ApiList";
import moment from "moment/moment";
import Loader from "../../Components/Loader";
const UserDetails = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const user_id = location?.state?.id;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const getUserDetails = async (params) => {
    setLoading(true);
    try {
      const response = await AxiosInstance.post(ApiList.USER_GET, params);
      if (response?.data?.s === 1) {
        setData(response?.data?.r);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const fetchUserList = () => {
    if (!user_id) {
      console.error("User ID is not defined");
      return;
    }

    const params = {
      select: `u.*,ua.apikey,ua.token,(select count(id) from feed where user_id = ${user_id} and status = 1) AS feed_count`,
      from: "users u JOIN user_auth ua ON u.id = ua.user_id LEFT JOIN feed AS f ON f.user_id = u.id",
      childEntity: `{"dog_details":{"select":"ud.*, db.name AS breed_name, COALESCE((SELECT SUM(dwa.distance) FROM dog_walk_activity dwa WHERE FIND_IN_SET(ud.id, dwa.user_dogs_id) > 0 AND dwa.user_id = ud.user_id), 0) AS mileage","from":"user_dogs AS ud JOIN dog_breed AS db ON db.id = ud.breed_id","arg":"ud.user_id = ? AND ud.status = 1","prms":[":;id"]}}`,
      arg: `u.id=${user_id}`,
      order: "u.id DESC",
      limit: 1,
    };

    getUserDetails(params);
  };
  useEffect(() => {
    fetchUserList();
  }, []);
  console.log(data);
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          background: "#B9CC0310",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: "100%",
            p: 2,
            background: "#B9CC0310",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <IconButton onClick={() => navigation(-1)}>
            <ArrowBackIcon sx={{ color: "#000", fontSize: "28px" }} />
          </IconButton>
          <Typography
            sx={{
              fontSize: { xs: "18px", md: "28px" },
              fontWeight: "300",
              color: "#000",
            }}
          >
            User Profile
          </Typography>
        </Box>
        {loading ? (
          <Loader />
        ) : (
          <Box
            sx={{
              width: "100%",
              p: 2,
              height: "calc(100vh - 76px)",
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
              gap: "24px",
            }}
          >
            {/* User Profile Card */}
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                background: "#fff",
                borderRadius: "16px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                overflow: "hidden",
              }}
            >
              {/* Profile Image Section */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  p: 3,
                  background: "#e2ea94",
                }}
              >
                <Avatar 
                  sx={{ 
                    width: 120, 
                    height: 120,
                    border: "4px solid #fff",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  }}
                >
                  <img
                    src={data?.image ? `${ApiList.IMG_URL}${data?.image}` : DUMMY}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    alt="User"
                  />
                </Avatar>
              </Box>

              {/* User Info Section */}
              <Box
                sx={{
                  flex: 1,
                  p: 3,
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                    gap: 3,
                  }}
                >
                  {/* Username */}
                  <Box>
                    <Typography
                      sx={{
                        color: "#00000080",
                        fontSize: "12px",
                        fontWeight: "500",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        mb: 0.5,
                      }}
                    >
                      Username
                    </Typography>
                    <Typography
                      sx={{
                        color: "#000",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      {data?.username || "N/A"}
                    </Typography>
                  </Box>

                  {/* Full Name */}
                  <Box>
                    <Typography
                      sx={{
                        color: "#00000080",
                        fontSize: "12px",
                        fontWeight: "500",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        mb: 0.5,
                      }}
                    >
                      Full Name
                    </Typography>
                    <Typography
                      sx={{
                        color: "#000",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      {`${data?.fname || ""} ${data?.lname || ""}`.trim() || "N/A"}
                    </Typography>
                  </Box>

                  {/* Email */}
                  <Box>
                    <Typography
                      sx={{
                        color: "#00000080",
                        fontSize: "12px",
                        fontWeight: "500",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        mb: 0.5,
                      }}
                    >
                      Email
                    </Typography>
                    <Typography
                      sx={{
                        color: "#000",
                        fontSize: "16px",
                        fontWeight: "600",
                        wordBreak: "break-word",
                      }}
                    >
                      {data?.email || "N/A"}
                    </Typography>
                  </Box>

                  {/* Streaks */}
                  <Box>
                    <Typography
                      sx={{
                        color: "#00000080",
                        fontSize: "12px",
                        fontWeight: "500",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        mb: 0.5,
                      }}
                    >
                      Streaks
                    </Typography>
                    <Box
                      sx={{
                        background: "#e2ea94",
                        borderRadius: "12px",
                        display: "inline-flex",
                        alignItems: "center",
                        px: 2,
                        py: 1,
                        gap: 1,
                        boxShadow: "0 2px 6px rgba(185, 204, 3, 0.3)",
                      }}
                    >
                      <img
                        src={Fire}
                        style={{ width: "24px", height: "24px" }}
                        alt="Fire"
                      />
                      <Typography 
                        sx={{ 
                          fontSize: "18px", 
                          fontWeight: "700",
                          color: "#000",
                        }}
                      >
                        {data?.streak_count || 0}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* Dog Details Section */}
            {data?.dog_details && data.dog_details.length > 0 && (
              <Box>
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#000",
                    mb: 2,
                    px: 1,
                  }}
                >
                  Pet Details ({data.dog_details.length})
                </Typography>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "1fr",
                      sm: "repeat(2, 1fr)",
                      md: "repeat(3, 1fr)",
                      lg: "repeat(4, 1fr)",
                    },
                    gap: 2,
                  }}
                >
                  {data.dog_details.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        background: "#fff",
                        borderRadius: "16px",
                        overflow: "hidden",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        transition: "transform 0.2s, box-shadow 0.2s",
                        "&:hover": {
                          transform: "translateY(-4px)",
                          boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                        },
                      }}
                    >
                      {/* Dog Image Header */}
                      <Box
                        sx={{
                          background: "#e2ea94",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          p: 2,
                        }}
                      >
                        <Avatar 
                          sx={{ 
                            width: 80, 
                            height: 80,
                            border: "3px solid #fff",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                          }}
                        >
                          <img
                            src={item?.image ? `${ApiList.IMG_URL}${item?.image}` : DUMMY}
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            alt={item?.name}
                          />
                        </Avatar>
                      </Box>

                      {/* Dog Details */}
                      <Box sx={{ p: 2 }}>
                        <Typography
                          sx={{
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#000",
                            mb: 2,
                            textAlign: "center",
                          }}
                        >
                          {item?.name || "Unknown"}
                        </Typography>

                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              pb: 1,
                              borderBottom: "1px solid #00000010",
                            }}
                          >
                            <Typography sx={{ color: "#00000080", fontSize: "13px", fontWeight: "500" }}>
                              Birth Date
                            </Typography>
                            <Typography sx={{ color: "#000", fontSize: "13px", fontWeight: "600" }}>
                              {moment(item?.birth_date).format("DD/MM/YYYY")}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              pb: 1,
                              borderBottom: "1px solid #00000010",
                            }}
                          >
                            <Typography sx={{ color: "#00000080", fontSize: "13px", fontWeight: "500" }}>
                              Breed
                            </Typography>
                            <Typography 
                              sx={{ 
                                color: "#000", 
                                fontSize: "13px", 
                                fontWeight: "600",
                                textAlign: "right",
                                maxWidth: "60%",
                              }}
                            >
                              {item?.breed_name || "Unknown"}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              pb: 1,
                              borderBottom: "1px solid #00000010",
                            }}
                          >
                            <Typography sx={{ color: "#00000080", fontSize: "13px", fontWeight: "500" }}>
                              Weight
                            </Typography>
                            <Typography sx={{ color: "#000", fontSize: "13px", fontWeight: "600" }}>
                              {item?.weight ? `${item.weight} kg` : "N/A"}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              pb: 1,
                              borderBottom: "1px solid #00000010",
                            }}
                          >
                            <Typography sx={{ color: "#00000080", fontSize: "13px", fontWeight: "500" }}>
                              Gender
                            </Typography>
                            <Typography sx={{ color: "#000", fontSize: "13px", fontWeight: "600" }}>
                              {item?.gender === 1 ? "Male" : "Female"}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography sx={{ color: "#00000080", fontSize: "13px", fontWeight: "500" }}>
                              Mileage
                            </Typography>
                            <Box
                              sx={{
                                background: "#e2ea94",
                                borderRadius: "8px",
                                px: 1.5,
                                py: 0.5,
                              }}
                            >
                              <Typography sx={{ color: "#000", fontSize: "13px", fontWeight: "700" }}>
                                {item?.mileage ? `${parseFloat(item.mileage).toFixed(2)} mi` : "0 mi"}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            )}
          </Box>
        )}
      </Box>
    </>
  );
};

export default UserDetails;
